import qs from "qs";
import { formatLocalTime, formatUTCTime } from "@/utils/time";
import { generateCircleWithLetter } from "@/utils/tool";
import { useSetting } from "@/composables/use-setting";

// 根据后端返回的数据结构改为适合组件用的数据结构
export const filterMsgTypeInfo = (
  data,
  isSend = false,
  staticInfo,
  imUserData,
  t,
) => {
  const { formatPrice } = useSetting();
  const {
    messageId,
    conversationId,
    content,
    contentTranslate,
    contentTranslateSend,
    headImage,
    messageType,
    nickname,
    // needAck,
    right,
    read,
    cardGoods,
    cardOrder,
    cardUserPoints,
    cardEvaluationInvitation,
    multimedia,
    afterQueueSend,
    emojiReplyMessages,
    replyMessage,
    timestamp,
  } = data;
  let msg = null;
  if (messageType === "CARD_GOODS_DETAIL" && cardGoods) {
    const {
      mainImage,
      // goodsName,
      goodsNameTranslate,
      // sendButtonText,
      // customerPriceMax,
      customerPriceMin,
      customerSchema,
      toImUserType,
      // latestTime
    } = cardGoods;
    msg = {
      _id: messageId,
      content: "[card]",
      roomId: conversationId,
      senderId: right ? imUserData.value.imUserIdStr : "0",
      username: nickname,
      loading: false,
      card: {
        time: formatUTCTime("HH:mm:ss"),
        image: mainImage,
        title: goodsNameTranslate,
        price: formatPrice(customerPriceMin),
        type: "goods",
        isSend: isSend || toImUserType === "CUSTOMER",
        appUrl: customerSchema,
        cardGoods,
        sendTxt: staticInfo.value.sendTxt,
      },
    };
  } else if (messageType === "CARD_ORDER_DETAIL" && cardOrder) {
    const {
      // showOrderId,
      showDetailId,
      orderCreateTime,
      mainImage,
      // goodsName,
      goodsNameTranslate,
      orderPriceCustomer,
      customerSchema,
      subOrderDeliverStatusNameTranslate,
      orderGoodsCount,
      skuNameTranslate,
      toImUserType,
    } = cardOrder;
    msg = {
      _id: messageId,
      content: "[card]",
      roomId: conversationId,
      senderId: right ? imUserData.value.imUserIdStr : "0",
      username: nickname,
      loading: false,
      card: {
        orderNo: showDetailId,
        time: formatUTCTime("MM-DD HH:mm", orderCreateTime) + "(UTC time)",
        image: mainImage,
        title: goodsNameTranslate,
        price: formatPrice(orderPriceCustomer),
        orderStatus: subOrderDeliverStatusNameTranslate,
        type: "order",
        quantity: orderGoodsCount,
        specification: skuNameTranslate,
        isSend: isSend || toImUserType === "CUSTOMER",
        appUrl: customerSchema,
        cardOrder,
        orderTimeTxt: staticInfo.value.orderTimeTxt,
        orderIdTxt: staticInfo.value.orderIdTxt,
        sendTxt: staticInfo.value.sendTxt,
      },
    };
  } else if (messageType === "CARD_GOODS_GUIDE_BOOK" && cardGoods) {
    const { customerSchema, toImUserType, sendButtonText } = cardGoods;
    msg = {
      _id: messageId,
      content: "[card]",
      roomId: conversationId,
      senderId: right ? imUserData.value.imUserIdStr : "0",
      username: nickname,
      loading: false,
      card: {
        ...cardGoods,
        messageType,
        time: formatUTCTime("HH:mm:ss"),
        isSend: isSend || toImUserType === "CUSTOMER",
        appUrl: customerSchema,
        btnTxt: sendButtonText || t("message.check_the_user_manual"),
      },
    };
  } else if (messageType === "CARD_USER_POINTS_INFO" && cardUserPoints) {
    const { toImUserType } = cardUserPoints;
    msg = {
      _id: messageId,
      content: "[card]",
      roomId: conversationId,
      senderId: right ? imUserData.value.imUserIdStr : "0",
      username: nickname,
      loading: false,
      card: {
        ...cardUserPoints,
        messageType,
        time: formatUTCTime("HH:mm:ss"),
        isSend: isSend || toImUserType === "CUSTOMER",
      },
    };
  } else if (
    messageType === "MULTIMEDIA_VIDEO_MESSAGES" ||
    messageType === "MULTIMEDIA_PICTURE_MESSAGE" ||
    messageType === "MULTIMEDIA_FILE_MESSAGES"
  ) {
    const {
      url,
      fileName,
      fileType,
      fileSize,
      // extension,
      fileWidth,
      fileHeight,
    } = multimedia || {};
    msg = {
      _id: messageId,
      content: "",
      roomId: conversationId,
      senderId: right ? imUserData.value.imUserIdStr : "0",
      username: nickname,
      loading: false,
      fileType,
      files: [
        {
          name: fileName,
          size: fileSize,
          type: fileType,
          audio: true,
          preview: url,
          url: url,
          width: fileWidth,
          height: fileHeight,
        },
      ],
    };
  } else {
    msg = {
      _id: messageId,
      content: right ? content : contentTranslate || contentTranslateSend,
      roomId: conversationId,
      senderId: right || afterQueueSend ? imUserData.value.imUserIdStr : "0",
      username: nickname,
      loading: false,
      cardEvaluationInvitation,
    };
  }
  const system = [
    "SYSTEM_NOTIFICATIONS_CUSTOMER_IDENTIFICATION",
    "SYSTEM_NOTIFICATIONS_CUSTOMER_IDENTIFICATION_CLOSE",
    "SYSTEM_NOTIFICATIONS_EVALUATION_INVITATION",
  ].includes(messageType);
  if (system) {
    msg.content = msg.content.replace(
      /%%(.*?)%%/g,
      "<usertag>clickReview</usertag>",
    );
    if (cardEvaluationInvitation) {
      msg.cardEvaluationInvitation = cardEvaluationInvitation;
      msg.noClass = true;
    }
    if (content.indexOf("joined") > -1) {
      msg.join = true;
      msg.headImage = headImage;
    }
  }

  const reactions = {};
  if (emojiReplyMessages) {
    emojiReplyMessages.forEach((e) => {
      reactions[`${decodeURI(e.emoji)}`] = e.nicknames;
    });
  }

  Object.assign(msg, {
    timestamp: formatLocalTime("HH:mm", timestamp),
    date: formatLocalTime("DD/MM/YYYY", timestamp),
    seen: read,
    system,
    messageType,
    reactions,
    replyMessage: replyMessage
      ? filterMsgTypeInfo(replyMessage, true, staticInfo, imUserData, t)
      : null,
  });
  return msg;
};

export const filterMsgSendInfo = (
  msgData,
  conversationId,
  selectedRoomInfo,
) => {
  const {
    messageId,
    // applyId,
    content: msgStr,
    // roomId,
    msgType,
    card,
    files,
  } = msgData || {};
  let msg = {};
  if (msgType === "text") {
    msg = {
      conversationId,
      messageId,
      content: msgStr,
      needAck: true,
      sessionId: selectedRoomInfo.sessionId,
      messageType: "NORMAL_TEXT",
    };
  } else if (msgType === "card") {
    if (card.type === "goods") {
      msg = {
        conversationId,
        messageId,
        needAck: true,
        sessionId: selectedRoomInfo.sessionId,
        messageType: "CARD_GOODS_DETAIL",
        cardGoods: card.cardGoods,
      };
    }
    if (card.type === "order") {
      msg = {
        conversationId,
        messageId,
        needAck: true,
        sessionId: selectedRoomInfo.sessionId,
        messageType: "CARD_ORDER_DETAIL",
        cardOrder: card.cardOrder,
      };
    }
  } else if (msgType === "file") {
    const file = files[0];
    let messageType = "MULTIMEDIA_FILE_MESSAGES";
    if (file.type.includes("image/")) {
      messageType = "MULTIMEDIA_PICTURE_MESSAGE";
    } else if (file.type.includes("video/")) {
      messageType = "MULTIMEDIA_VIDEO_MESSAGES";
    }
    msg = {
      conversationId,
      messageId,
      needAck: true,
      sessionId: selectedRoomInfo.sessionId,
      messageType,
      multimedia: {
        url: file.url || file.localUrl,
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
        extension: file.extension,
        fileHeight: file.height,
        fileWidth: file.width,
      },
    };
  }
  return msg;
};

export const reviewUser = { _id: "clickReview", username: "Click here" };

export function filterRoom(conversations, imUserData) {
  const headColorList = ["#FFBF58", "#6D87E6", "#B077E9", "#5AD28A", "#FF865F"];
  const { imUserIdStr, nickname: imUserNickname } = imUserData.value;
  const newRooms = conversations?.map((e, i) => {
    const colorIndex = i % 5;
    const color = headColorList[colorIndex];
    const timestamp = e.latestTimestamp
      ? formatLocalTime("HH:mm", e.latestTimestamp)
      : "";
    const date = e.latestTimestamp
      ? formatLocalTime("DD/MM/YYYY", e.latestTimestamp)
      : "";
    if (e.conversationId) {
      return {
        categoryExperts: e.categoryExperts,
        roomId: e.conversationId,
        roomName: e.nickname,
        avatar:
          e.headImage ||
          generateCircleWithLetter(e.nickname.slice(0, 1), color),
        robot: e.robot,
        sessionId: e.sessionId,
        sessionOpen: e.sessionOpen,
        toCombineId: e.toCombineId,
        toUserRole: e.toUserRole,
        toUserType: e.toUserType,
        unreadCount: e.unreadCount,
        hasOrder: e.hasOrder,
        users: [
          { _id: imUserIdStr, username: imUserNickname },
          { _id: e.conversationId, username: e.nickname },
          reviewUser,
        ],
        lastMessage: {
          content: e.right ? e.latestContent : e.latestContentTranslate,
          timestamp,
          date,
          // todo 先留空，历史会话列表里目前没有返回对应的客服人员名称
          username: "",
        },
      };
    }
    return {
      avatar: e.headImage,
      categoryExperts: e.categoryExperts,
      roomId: -i - 10,
      roomName: e.nickname,
      unreadCount: 0,
      toUserRole: e.toUserRole,
      toUserType: e.toUserType,
      users: [{}],
      lastMessage: {
        content: e.right ? e.latestContent : e.latestContentTranslate,
      },
      isCustom: true,
    };
  });
  return newRooms;
}

export function parseWsDataString(str) {
  const regex = /^(\d+):(\{[\s\S]*\})/;
  const match = str.match(regex);
  if (match) {
    const code = Number(match[1]); // 匹配到的数字
    let jsonString = match[2];

    // 替换换行符
    jsonString = jsonString.replace(/[\n\t]/g, (char) => {
      return char === "\n" ? "\\n" : "\\t";
    });

    const data = JSON.parse(jsonString); // 冒号后面的内容

    return { code, data };
  } else {
    return null; // 如果未匹配到任何内容，则返回 null
  }
}

export function getCustomServiceRoom(imUserData) {
  return {
    roomId: 0,
    roomName: "Voghion Customer Service",
    avatar:
      "https://g-images.voghion.com/productImages/177_1715253448467_voghion100x100.png",
    isCustom: true,
    sessionId: "0",
    sessionOpen: true,
    tipTxt: "Official",
    users: [{ _id: imUserData.imUserIdStr, username: imUserData.nickname }],
    lastMessage: {
      content: "Hi.Welcome to Voghion shopping.",
    },
  };
}

export const getResource = () => {
  const hashQuery = window.location.hash.slice(2).split("?")[1];
  const hashStr = hashQuery ? hashQuery : "";
  const parseData = qs.parse(hashStr);
  return parseData;
};

export const getIsPlatformPC = () => {
  const { platform } = getResource();
  return platform === "PC";
};

export const isSingleRoom = () => {
  const { pageFrom } = getResource();
  const isSingleRoomBoolean = [
    "goodsDetail",
    "orderDetail",
    "orderList",
    "orderListRightsideTopIcon",
    "orderDetailRightSideTopIcon",
    "orderConfirm",
    "recommended",
    "payment",
    "push",
    "venueActivities",
    "categorySecondLevelList",
    "categorySecondLevelList",
    "shippingAddress",
    "listByTags",
    "favorites",
    "coupon",
    "viewed",
    "pcHome",
    "refundDetail",
    "afterSaleServicePage",
    // 'homeBottomButton','me',
  ].includes(pageFrom);
  return isSingleRoomBoolean;
};
